import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '@app-services/user/user.service';
import { ClassSessionService } from 'src/app/core/services/class-session.service';

@Component({
  selector: 'app-report-issue-dialog',
  templateUrl: './report-issue-dialog.component.html',
  styleUrls: ['./report-issue-dialog.component.css']
})
export class ReportIssueDialogComponent implements OnInit {

  public isSkipDisabled: boolean = false;

  public isSubmitDisabled: boolean = true;

  public userTypeId: number = 1;

  public reportAnIssueTitle: string = "Report an Issue"

  public reportAnIssueQuestion: Array<any> = [];

  constructor(
    private _userService: UserService,
    private dialogRef: MatDialogRef<ReportIssueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sessionService: ClassSessionService,
  ) { }

  ngOnInit(): void {
    let _userTypeId = this._userService.getUserType();

    if(_userTypeId == 1) {
      this.reportAnIssueQuestion = [
        {
          "title": "1. Audio and Video",
          "options": [
            {
              "label": "Unable to see teacher's video",
              "key": "unableToSeeTeacherVideo",
              "selected": false
            },
            {
              "label": "Unable to hear teacher's audio",
              "key": "unableToHearTeacherAudio",
              "selected": false
            }
          ]
        },
        {
          "title": "2. Content",
          "options": [
            {
              "label": "Unable to see content shared by teacher",
              "key": "unableToSeeContentSharedByTeacher",
              "selected": false
            }
          ]
        }
      ]
    } else {
      this.reportAnIssueQuestion = [
        {
          "title": "1. Audio and Video",
          "options": [
            {
              "label": "Unable to see my video",
              "key": "unableToSeeMyVideo",
              "selected": false
            },
            {
              "label": "Unable to hear my audio",
              "key": "unableToHearMyAudio",
              "selected": false
            }
          ]
        },
        {
          "title": "2. Content",
          "options": [
            {
              "label": "Unable to see content shared by Me",
              "key": "unableToSeeContentSharedByMe",
              "selected": false
            }
          ]
        }
      ]
    }

    this.reportAnIssueQuestion.push(
      {
        "title": "3. Chats",
        "options": [
          {
            "label": "Unable to see chat messages",
            "key": "unableToSeeChatMsg",
            "selected": false
          },
          {
            "label": "Unable to send chat messages",
            "key": "unableToSendChatMsg",
            "selected": false
          }
        ]
      }
    )
  }

  skipReportAnIssue = () => {
    this.dialogRef.close({ event: 'skip' });
  }

  updateFormValue = (_index: number, _key: any) => {
    let _reqObj = this.reportAnIssueQuestion[_index];
    _reqObj.options.map((item: any) => { item.key == _key ? item.selected = !item.selected : item.selected = item.selected });

    this.checkSubmitStillDisabled();
  }

  checkSubmitStillDisabled = () => {
    let _firstQuesSelectionLen = this.reportAnIssueQuestion[0].options.filter((x: any) => x.selected == true).length;
    let _secQuesSelectionLen = this.reportAnIssueQuestion[1].options.filter((x: any) => x.selected == true).length;
    let _thiredQuesSelectionLen = this.reportAnIssueQuestion[2].options.filter((x: any) => x.selected == true).length;

    if (_firstQuesSelectionLen > 0 || _secQuesSelectionLen > 0 || _thiredQuesSelectionLen > 0) {
      this.isSubmitDisabled = false;
    } else {
      this.isSubmitDisabled = true;
    }
  }

  submitReportAnIssueForm = () => {
    this.isSkipDisabled = true;

    this.userTypeId = this._userService.getUserType();

    let _formValues: any = {
      title: this.reportAnIssueTitle,
      questions: this.reportAnIssueQuestion,
      class: this.data.eclassInfo.id,
      tenant: 123,
      status: 'active'
    }

    if(this.userTypeId == 1){
      _formValues.student = {
        id: this.data.crntUserInfo.userId,
        firstName: this.data.crntUserInfo.firstName,
        lastName: this.data.crntUserInfo.lastName,
      }
    }

    this.sessionService.submitSessionIssueReport(_formValues).subscribe(
      (res: any) => {
        this.isSkipDisabled = false;
        console.log("Report An Issue Success Response: ", res);
        this.dialogRef.close({ event: 'issue-repoted' });
      },
      (err: any) => {
        this.isSkipDisabled = false;
        console.log("Report An Issue Error Response: ", err)
      }
    )
  }

}
